export enum RelationshipStatus {
  PendingApproval = "PendingApproval",
  Approved = "Approved",
  Rejected = "Rejected",
  PendingCompletion = "PendingCompletion",
  CompletionReturned = "CompletionReturned",
}
